<script lang="ts">
	import { cfgToThemeCdnPath } from '@infinitro/config';
	import { isMobile } from '@infinitro/global';
	import { derived } from 'svelte/store';

	type ScrollBannerItem = {
		id: string;
		targetUrl: string;
	};

	export let items: ScrollBannerItem[] = [
		{ id: '01', targetUrl: '/' },
		{ id: '02', targetUrl: '/' },
		{ id: '03', targetUrl: '/' }
	];
	export let imagePathPrefix: string = '/home-page/card';
	export let imagePathSuffix: string = '.png';

	const imgInfos$ = derived(isMobile, ($_isMobile) => {
		return items.map((item) => {
			const path = `${imagePathPrefix}${item.id}-${$_isMobile ? 'm' : 'd'}${imagePathSuffix}`;
			const imgPath = cfgToThemeCdnPath(path);
			return {
				imgPath,
				targetUrl: item.targetUrl
			};
		});
	});
</script>

<div class="wrapper-scroll">
	<div class="container">
		{#each $imgInfos$ as item, i (item.imgPath)}
			<button class="card">
				<img class="img" src={item.imgPath} alt="" />
			</button>
		{/each}
	</div>
</div>

<style>
	.wrapper-scroll {
    width: 105%;
    overflow-x: auto
}
	@media (min-width: 768px) {
    .wrapper-scroll {
        width: 100%
    }
}
	.container {
    display: flex;
    width: -moz-fit-content;
    width: fit-content;
    flex-direction: row;
    align-items: flex-start;
    gap: 1rem
}
	@media (min-width: 768px) {
    .container {
        width: 100%
    }
}
	.container {
    margin-bottom: 1rem
}
	.card {
    width: 300px;
    overflow: hidden;
    border-radius: 12px;
    background-color: var(--color-background-500)
}
	@media (min-width: 768px) {
    .card {
        width: 100%
    }
}
	.img {
    display: block;
    height: auto;
    width: 100%
}
</style>
